import styled from "styled-components";
import theme from "~/styles/theme";

export const FormHolder = styled.div`
  padding: 0 16px;
  margin: 0 auto;
  text-align: center;
  p {
    color: ${theme.palette.brand.primary.dark};
    span {
      cursor: pointer;
      font-family: ${theme.typography.secondaryFont};
      text-decoration: underline;
      text-transform: uppercase;
    }
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    width: 100%;

    > div {
      width: 100%;
    }
    p {
      width: 100%;
    }
  }
`;

export const FormLimiter = styled.form`
  button {
    width: 100%;
  }
  @media (min-width: ${theme.breakpoints.values.md}px) {
    max-width: 560px;
    margin: 0 auto;
  }
`;

export const ForgotLink = styled.div`
  text-align: left;
  z-index: 100;
  position: sticky;

  a {
    font-size: 16px;
    color: ${theme.palette.brand.primary.key};
    font-family: ${theme.typography.fontFamily};
    text-decoration: underline;
  }
`;

export const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;

  button {
    @media (min-width: ${theme.breakpoints.values.md}px) {
      max-width: 194px;
    }
  }
`;

export const TextHolder = styled.div`
  p {
    font-size: 16px;
    color: ${theme.palette.brand.primary.key};
    font-family: ${theme.typography.fontFamily};
    text-align: right;

    span {
      font-family: ${theme.typography.fontFamily};
    }
  }
`
